/**
 * 字符串转化
 * @param {字符串} str 
 * @param {符号} sign 
 */
function changeStr(str, sign = ',') {
  if (str[str.length - 1] == sign) {
    str = str.substr(0, str.length - 1)
  }
  return str
}
/**
 * 字符串转数组
 * @param {字符串} str 
 * @param {符号} sign 
 */
function changeStrArr(str, sign = ',') {
  let arr = []
  if (str[str.length - 1] == sign) {
    str = str.substr(0, str.length - 1)
  }
  if (str) {
    arr = str.split(sign)
  }
  return arr
}
/**
 * 对象转查询字符串
 * @param {对象} data 
 */
function changObjQuery(data) {
  let query = ''
  for (let key in data) {
    query += key + '=' + encodeURI(data[key]) + '&'
  }
  query = query.substr(0, query.length - 1)
  return query
}

/**
 * 将数组类型转成对象类型
 * @param {Array} arr 数组
 * @param {String} key 数组用来做对象key的值
 * @returns {Object}
 */
function arrToObj(arr, key) {
  let obj = {}
  arr.forEach(item => {
    obj[item[key]] = item
  })
  return obj
}
export {
  changeStr,
  changeStrArr,
  changObjQuery,
  arrToObj
}